var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "g-row g-row--justify_between g-row--align_center g-cell"
      },
      [
        _c("div", { staticClass: "el el--p_t_2xs-xl el--p_t_1xs" }, [
          _c(
            "h1",
            {
              staticClass:
                "ds-caption ds-caption--c_white ds-caption--w_r-xl ds-caption--w_m ds-caption--size_8vw-xl ds-caption--size_4xl-md ds-caption--size_30xl ds-caption--h_130 ds-caption ds-caption--upp",
              attrs: { id: "topblock" }
            },
            [_vm._v(_vm._s(_vm.transText.title))]
          )
        ]),
        _c("v-select", {
          staticClass: "vue-select",
          attrs: {
            options: _vm.listTitle,
            label: "tag",
            reduce: function(options) {
              return options.tag
            },
            clearable: false,
            searchable: false
          },
          on: {
            input: function($event) {
              return _vm.sortCards()
            }
          },
          model: {
            value: _vm.formData.tag,
            callback: function($$v) {
              _vm.$set(_vm.formData, "tag", $$v)
            },
            expression: "formData.tag"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "el el--p_t_xl-lg el--p_t_1sm",
        attrs: {
          "data-aos": "fade-up",
          "data-aos-once": "false",
          "data-aos-duration": "700",
          "data-aos-delay": "400"
        }
      },
      [
        _c("transition", { attrs: { duration: 700, name: "nested" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showTest,
                  expression: "showTest"
                }
              ],
              staticClass: "g-row g-row--space_10xl inner"
            },
            _vm._l(_vm.cardsList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "g-cols g-cols--12 g-cols--6-md g-cols--4-xl g-cols--n_height g-cell el-cards-outlainer"
                },
                [
                  _c("div", { staticClass: "cards-solutions" }, [
                    _c("div", { staticClass: "cards-solutions__wrap" }, [
                      _c("div", { staticClass: "cards-solutions__img" }, [
                        _c("img", { attrs: { src: item.img } })
                      ]),
                      _c("div", { staticClass: "el" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "ds-caption ds-caption--c_white ds-caption--size_lg ds-caption--w_r ds-caption--h_130 ds-caption--upp"
                          },
                          [_vm._v(_vm._s(item.title))]
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "el el--p_t_lg-lg el--p_t_sm" },
                        [
                          _c("p", {
                            staticClass:
                              "ds-caption ds-caption--c_white ds-caption--size_md-lg ds-caption--size_1xs ds-caption--w_l ds-caption--h_200 ds-caption--op-4-lg",
                            domProps: { innerHTML: _vm._s(item.text) }
                          })
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "el el--p_t_lg-lg el--p_t_1md" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "ds-caption ds-caption--c_white ds-caption--size_md-lg ds-caption--size_11xs ds-caption--w_r ds-caption--h_130"
                        },
                        [_vm._v(_vm._s(_vm.transText.cardsTitle))]
                      )
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ])
      ],
      1
    ),
    _vm.recordsLength > _vm.perPage
      ? _c(
          "div",
          [
            _c("ui-limit-pagination", {
              attrs: {
                "current-page": Number(_vm.page),
                "per-page": _vm.perPage,
                total: _vm.recordsLength
              },
              on: {
                page: function($event) {
                  _vm.getPage($event), _vm.scrollToTop()
                }
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69eb3541", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69eb3541","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/UiElements/FilterCards.vue
// module id = 122
// module chunks = 0